<template>
	<sf-data-table
		ref="dataTable"
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		paging
		index
		v-bind="pagingInfo"
		:columns="columns"
		:stripe="false"
		:rows="rows"
		fit="fit"
		selection
		:excel="isButton_(scrId, 'EX')"
		:customExcel="excelFunc"
		@changedPage="changedPage"
		@row-click="rowClick"
	>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'edit'">
				<i class="icon-sf-edit" style="cursor: pointer"></i>
			</template>
			<template v-if="slotProps.column.property === 'pprNo'">
				<template v-if="!!slotProps.row.pprNo">
					<span class="highlighted" @click="() => pprNoClick(slotProps.row)">{{ slotProps.row.pprNo }}</span>
				</template>
				<template v-else-if="slotProps.row.badClCd === 'M'">
					<!-- 부붐 분류가 제조(M)이면 보고서 작성 불가능 -->
					<span>
						{{ getMessage_('QWCC001702') }}
					</span>
				</template>
				<template v-else>
					<!-- 보고서 작성 -->
					<span class="highlighted" @click="() => pprNoClick(slotProps.row)">{{ getMessage_('QWCC001703') }} </span>
				</template>
			</template>
		</template>
		<template v-slot:actionsLeft>
			<sf-button v-if="isButton_(scrId, 'CU') && isPqyUser" line icon="file" :onClick="saveAction">
				{{ getMessage_('QWCC001131') }}
			</sf-button>
			<sf-button line v-if="isButton_(scrId, 'CS') && isPqyUser" icon="trash" color="error" :onClick="deleteAction">{{
				getMessage_('QWCC001136')
			}}</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import { BASE_URL } from '@/constants';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';

export default {
	props: { scrId: { type: String, default: '' } },
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.resultList;
		},
		columns() {
			return this.getColumns_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		},
		saveAction() {
			this.setState_({ key: 'isSaved', value: true });
		},
		pprNoClick(row) {
			this.clickPprPgsStNm(row);
		},
		rowClick(row) {
			this.setState_({ key: 'selectedRow', value: row });
		},
		clickPprPgsStNm(row) {
			this.$emit('OpenPopup', row);
		},
		deleteAction() {
			//체크박스로 선택된 행이 있는지 확인
			const selected = this.$refs.dataTable.getSelectedRows();
			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			// 유효성 검사
			try {
				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001196'), //삭제하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001136'), clickFn: this.deleteOverSrgAltrList }] //저장
				});
				// }
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async deleteOverSrgAltrList() {
			this.$sf_toggleLoading(true);
			try {
				const delRows = this.$refs.dataTable.getSelectedRows();

				// 저장 전 Grid 유효성 체크
				this.makeValidateGrid(delRows);
				
				// console.log(delRows);
				// const partNo = this.searchParams.partNo;
				// const params = {  reqBody: delRows };
				const { code, messageCd } = await this.deleteOverSrgAltrList_(delRows);
				//console.log(code, messageCd);
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
					code === 0 && this.$emit('Refresh');
				}
				// this.resetTable();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		makeValidateGrid(resultList) {
			
			let passYn = 'Y';
			let errColumn = '';
			let fullYn = '';
			//console.log(resultList);
			
			for (let i = 0; i < resultList.length; i++) {
				let overSrgNo = resultList[i].overSrgNo;
				let pprNo = resultList[i].pprNo;
				if(pprNo){
					passYn = 'N';
					errColumn = overSrgNo;
					break;
				}
				
			}
			

			if (passYn === 'N') {
				throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC002086'), [errColumn])); //{0} 열을 모두 입력해주시기 바랍니다.
			}
		},
		excelFunc() {
			const queryStr = this.$sf_objectToQueryString({
				strDt: this.searchParams.strDt.replaceAll('-', ''),
				endDt: this.searchParams.endDt.replaceAll('-', ''),
				partNo: this.searchParams.partNo,
				rgnId: this.searchParams.rgnId,
				powCd: this.searchParams.powCd
			});
			const url = `${BASE_URL}/pqy/pcku/overSrgAltr/v1/excels${queryStr}`;
			this.$sf_xlsxDown({ url, columns: this.columns }).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		}
	}
};
</script>
